module.exports = __webpack_public_path__ + "static/img/other_FAQ_pic07.6c1f3c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/other_FAQ/other_FAQ_pic07.png
// module id = 559
// module chunks = 1